module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-exhausting.caf5e4c0.svg";